import Title from "./Title";
import Project from "./Project";
import { projects } from "../data";
const Projects = () => {
  return (
    <>
      <section className='section' id='projects'>
        <Title Text1='featured' Text2='Projects' />

        <div className='section-center featured-center'>
          {projects.map((project) => {
            return <Project key={project.id} {...project} />;
          })}
        </div>
      </section>
    </>
  );
};
export default Projects;
